import React from 'react';

import { TavernField } from '../../../ui/components';
import { formatDateYYYYMMDD, parseDateYYYYMMDD } from '../../../utils/date';

export type EventTimeSectionProps = {
  dateValue: string;
  startTime: string;
  endTime: string;
  today: Date;
  isSubmitting: boolean;
  dateError: string | null;
  timeError: string | null;
  onDateChange: (date: Date) => void;
  onDateBlur: () => void;
  onStartTimeChange: (value: string) => void;
  onStartTimeBlur: () => void;
  onEndTimeChange: (value: string) => void;
  onEndTimeBlur: () => void;
};

export const EventTimeSection = React.memo(function EventTimeSection({
  dateValue,
  startTime,
  endTime,
  today,
  isSubmitting,
  dateError,
  timeError,
  onDateChange,
  onDateBlur,
  onStartTimeChange,
  onStartTimeBlur,
  onEndTimeChange,
  onEndTimeBlur,
}: EventTimeSectionProps) {
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const next = parseDateYYYYMMDD(e.target.value);
    if (next) onDateChange(next);
  };

  return (
    <div className="ttbFormSection">
      <div className="ttbFormSectionHeader">
        <span className="ttbFormSectionIcon">📅</span>
        <h2 className="ttbFormSectionTitle">Время</h2>
      </div>

      <TavernField label="Дата" required error={dateError}>
        <input
          type="date"
          value={dateValue}
          min={formatDateYYYYMMDD(today)}
          disabled={isSubmitting}
          onBlur={onDateBlur}
          onChange={handleDateChange}
          className={['ttbInput', dateError ? 'ttbInputError' : null].filter(Boolean).join(' ')}
        />
      </TavernField>

      <TavernField label="Время начала" required error={timeError}>
        <input
          type="time"
          step={900}
          value={startTime}
          disabled={isSubmitting}
          onBlur={onStartTimeBlur}
          onChange={(e) => onStartTimeChange(e.target.value)}
          className={['ttbInput', timeError ? 'ttbInputError' : null].filter(Boolean).join(' ')}
        />
      </TavernField>

      <TavernField label="Время окончания" required hint="Шаг 15 минут">
        <input
          type="time"
          step={900}
          value={endTime}
          disabled={isSubmitting}
          onBlur={onEndTimeBlur}
          onChange={(e) => onEndTimeChange(e.target.value)}
          className={['ttbInput', timeError ? 'ttbInputError' : null].filter(Boolean).join(' ')}
        />
      </TavernField>
    </div>
  );
});
